export function gcd(a: number, b: number): number {
    return (b === 0) ? a : gcd(b, a%b);
}

export function toDecimalsAsNumber(value: number, decimals: number): number {
    return parseFloat(value.toFixed(decimals));
}
